import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import LoadingButton from '../../skeletons/loadingButton';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteForm, saveForm } from '../../store/Slices/formSlice';
import { generateLoa } from '../../store/Slices/generateSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function French() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const email = sessionStorage.getItem('email');
    const generateLoading = useSelector((state) => state.generate.loading);

    useEffect(() => {
        const fetchData = async () => {

            if (!email) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));
            if (form?.country?.country === 'France') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const fillForm = (form) => {
        const jsonData = form;
        document.querySelector('#name').value = jsonData?.country?.customerDetails?.name ?? '';
        document.querySelector('#companyName').value = jsonData?.country?.customerDetails?.companyName ?? '';
        document.querySelector('#legalForm').value = jsonData?.country?.customerDetails?.legalForm ?? '';
        document.querySelector('#amount').value = jsonData?.country?.customerDetails?.amount ?? '';
        document.querySelector('#address').value = jsonData?.country?.customerDetails?.address ?? '';
        document.querySelector('#city').value = jsonData?.country?.customerDetails?.city ?? '';
        document.querySelector('#number').value = jsonData?.country?.customerDetails?.number ?? '';
        document.querySelector('#customerRole').value = jsonData?.country?.customerDetails?.customerRole ?? '';
        document.querySelector('#operator').value = jsonData?.country?.customerDetails?.operator ?? '';
        document.querySelector('#necessaryAct').value = jsonData?.country?.customerDetails?.necessaryAct ?? '';
        document.querySelector('#signature').value = jsonData?.country?.customerDetails?.signature ?? '';
        setName(jsonData?.country?.customerDetails?.name ?? '');
        setCompanyName(jsonData?.country?.customerDetails?.companyName ?? '');
        setLegalForm(jsonData?.country?.customerDetails?.legalForm ?? '');
        setAmount(jsonData?.country?.customerDetails?.amount ?? '');
        setAddress(jsonData?.country?.customerDetails?.address ?? '');
        setCity(jsonData?.country?.customerDetails?.city ?? '');
        setNumber(jsonData?.country?.customerDetails?.number ?? '');
        setCustomerRole(jsonData?.country?.customerDetails?.customerRole ?? '');
        setOperator(jsonData?.country?.customerDetails?.operator ?? '');
        setNecessaryAct(jsonData?.country?.customerDetails?.necessaryAct ?? '');
        setSignature(jsonData?.country?.customerDetails?.signature ?? '');

        document.querySelector('#sitesNumber').value = jsonData?.country?.site?.client?.sitesNumber ?? '';
        setSitesNumber(jsonData?.country?.site?.client?.sitesNumber ?? '');

        document.querySelector('#siteClient').value = jsonData?.country?.site?.client?.siteClient ?? '';
        setSiteClient(jsonData?.country?.site?.client?.siteClient ?? '');

        document.querySelector('#siteCompanyName').value = jsonData?.country?.site?.client?.siteCompanyName ?? '';
        setSiteCompanyName(jsonData?.country?.site?.client?.siteCompanyName ?? '');

        document.querySelector('#siteName').value = jsonData?.country?.site?.client?.siteName ?? '';
        setSiteName(jsonData?.country?.site?.client?.siteName ?? '');

        document.querySelector('#siteAddress').value = jsonData?.country?.site?.client?.siteAddress ?? '';
        setSiteAddress(jsonData?.country?.site?.client?.siteAddress ?? '');

        document.querySelector('#postalCode').value = jsonData?.country?.site?.client?.postalCode ?? '';
        setPostalCode(jsonData?.country?.site?.client?.postalCode ?? '');

        document.querySelector('#locality').value = jsonData?.country?.site?.client?.locality ?? '';
        setLocality(jsonData?.country?.site?.client?.locality ?? '');

        document.querySelector('#telephone').value = jsonData?.country?.site?.client?.telephone ?? '';
        setTelephone(jsonData?.country?.site?.client?.telephone ?? '');

        document.querySelector('#fax').value = jsonData?.country?.site?.client?.fax ?? '';
        setFax(jsonData?.country?.site?.client?.fax ?? '');

        document.querySelector('#idCode').value = jsonData?.country?.site?.client?.idCode ?? '';
        setIdCode(jsonData?.country?.site?.client?.idCode ?? '');

        document.querySelector('#siteOperator').value = jsonData?.country?.site?.client?.siteOperator ?? '';
        setSiteOperator(jsonData?.country?.site?.client?.siteOperator ?? '');

        document.querySelector('#tickbox').value = jsonData?.country?.site?.client?.tickbox ?? '';
        setTickbox(jsonData?.country?.site?.client?.tickbox ?? '');

        document.querySelector('#portability').value = jsonData?.country?.site?.client?.portability ?? '';
        setPortability(jsonData?.country?.site?.client?.portability ?? '');

        document.querySelector('#date').value = jsonData?.country?.portability?.dateAndTime?.date ?? '';
        document.querySelector('#time').value = jsonData?.country?.portability?.dateAndTime?.time ?? '';
        setDate(jsonData?.country?.portability?.dateAndTime?.date ?? '');
        setTime(jsonData?.country?.portability?.dateAndTime?.time ?? '');

        // document.querySelector('#accessType').value = jsonData?.country?.portability?.connectionType?.accessType ?? '';
        document.querySelector('#phoneNumber').value = jsonData?.country?.portability?.connectionType?.phoneNumber ?? '';
        // setAccessType(jsonData?.country?.portability?.connectionType?.accessType ?? '');
        setPhoneNumber(jsonData?.country?.portability?.connectionType?.phoneNumber ?? '');

        const numberOfTableRows = jsonData.country.portability.connectionType.DIDRange.length;
        for (let i = 0; i < numberOfTableRows; i++) {
            addRow();
        }
        setTableData(jsonData.country.portability.connectionType.DIDRange);

        document.querySelector('#iName').value = jsonData?.country?.portability?.businessTelInstaller?.name ?? '';
        document.querySelector('#iAddress').value = jsonData?.country?.portability?.businessTelInstaller?.address ?? '';
        document.querySelector('#iTelephone').value = jsonData?.country?.portability?.businessTelInstaller?.telephone ?? '';
        setIName(jsonData?.country?.portability?.businessTelInstaller?.name ?? '');
        setIAddress(jsonData?.country?.portability?.businessTelInstaller?.address ?? '');
        setITelephone(jsonData?.country?.portability?.businessTelInstaller?.telephone ?? '');

        const RIOdetails = jsonData?.country?.portability?.rioDetails?.rio;
        if (Object.keys(RIOdetails).length !== 0) {
            setSelectedOption('yes');
            document.querySelector('#rio').value = 'yes';

            setTimeout(() => {
                const accessTypeRIO = document.querySelector('#accessTypeRIO');
                const numberRIO = document.querySelector('#numberRIO');
                const idRIO = document.querySelector('#idRIO');

                if (accessTypeRIO) {
                    accessTypeRIO.value = RIOdetails?.accessType;
                }
                if (numberRIO) {
                    numberRIO.value = RIOdetails?.number;
                }
                if (idRIO) {
                    idRIO.value = RIOdetails?.id;
                }
            }, 0);
            setFormData(RIOdetails);
        }
        else {
            setSelectedOption('no');
        }
    }

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [name, setName] = useState();
    const [companyName, setCompanyName] = useState();
    const [legalForm, setLegalForm] = useState();

    const [amount, setAmount] = useState();
    const handleCapitalChange = (e) => {
        // Remove all non-digit characters except for the decimal point (if needed)
        const inputValue = e.target.value.replace(/[^\d.]/g, '');

        // Ensure there's at most one decimal point and properly format the input
        const parts = inputValue.split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // Add commas for thousands

        // If there's a decimal part, join it back; otherwise, just return the integer part
        const formattedValue = parts[1] ? `${integerPart}.${parts[1]}` : integerPart;

        // Update the state with the formatted value
        setAmount(formattedValue);
    };


    const [address, setAddress] = useState();
    const [city, setCity] = useState();
    const [number, setNumber] = useState();
    const [operator, setOperator] = useState();
    const [customerRole, setCustomerRole] = useState();
    const [necessaryAct, setNecessaryAct] = useState();
    const [signature, setSignature] = useState();

    const [clientType, setClientType] = useState();

    const [date, setDate] = useState();
    const [time, setTime] = useState();

    const [phoneNumber, setPhoneNumber] = useState();
    const [isMainline, setIsMainline] = useState(false);

    const [iName, setIName] = useState("");
    const [iAddress, setIAddress] = useState("");
    const [iTelephone, setITelephone] = useState("");

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------sections declaration (Site Details)-----------------------------------//

    const [sitesNumber, setSitesNumber] = useState("");
    const [siteClient, setSiteClient] = useState("");
    const [siteCompanyName, setSiteCompanyName] = useState("");
    const [siteName, setSiteName] = useState("");
    const [siteAddress, setSiteAddress] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [locality, setLocality] = useState("");
    const [telephone, setTelephone] = useState("");
    const [fax, setFax] = useState("");
    const [idCode, setIdCode] = useState("");
    const [siteOperator, setSiteOperator] = useState("");
    const [tickbox, setTickbox] = useState("");
    const [portability, setPortability] = useState("");

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), DIDRangeStart: '', DIDRangeStop: '' }]);

    //adding a row
    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), DIDRangeStart: '', DIDRangeStop: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    // change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableData(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-based index = 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            const dataRows = jsonData.slice(1);

            const formattedDataRange = dataRows.map((row, index) => ({
                id: Date.now() + index, // Ensure unique ID
                DIDRangeStart: row[0] ? row[0].toString() : '',
                DIDRangeStop: row[1] ? row[1].toString() : '',
            }));

            setTableData(formattedDataRange);

            // Update only DID range related validation states, preserving others
            setValidationStates(prev => {
                const updatedStates = { ...prev };
                const numberRegex = /^\d{1,14}$/;

                formattedDataRange.forEach(row => {
                    updatedStates[`start-${row.id}`] = !!row.DIDRangeStart && numberRegex.test(row.DIDRangeStart);
                    updatedStates[`end-${row.id}`] = !!row.DIDRangeStop && numberRegex.test(row.DIDRangeStop);
                });

                return updatedStates;
            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableData([{ id: Date.now(), DIDRangeStart: '', DIDRangeStop: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------code for rendering one section out of two (RIO Details)-------------------------//

    const [selectedOption, setSelectedOption] = useState('');
    const [formData, setFormData] = useState({});

    const handleDropdownChange = (e) => {
        setSelectedOption(e.target.value);
        // Reset form data when dropdown changes

        if (e.target.value === 'yes') {
            setFormData({
                accessType: "",
                number: "",
                id: ""
            })
        }
        else {
            setFormData({

            })
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const renderFormInputs = () => {
        switch (selectedOption) {
            case 'yes':
                return (
                    <div>

                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('accessType')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Type d’accès*</label> <br />
                                <input
                                    onChange={handleInputChange}
                                    type="text"
                                    id='accessTypeRIO'
                                    name='accessType'
                                    placeholder=""
                                    className={`inputbox ${validationStates.accessTypeRIO === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('accessTypeRIO', /^[\w\W,]+$/)}
                                />
                                {hoveredField === 'accessType' && (
                                    <div className="hover-description">
                                        Entrez le type d'accès
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('number')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Nombre*</label> <br />
                                <input
                                    onChange={handleInputChange}
                                    type="text"
                                    id='numberRIO'
                                    name='number'
                                    placeholder=""
                                    className={`inputbox ${validationStates.numberRIO === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('numberRIO', /^\+?[1-9]\d{1,14}$/)}
                                />
                                {hoveredField === 'number' && (
                                    <div className="hover-description">
                                        Entrez le numéro
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('id')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>RIO Identifiant*</label> <br />
                                <input
                                    onChange={handleInputChange}
                                    type="text"
                                    id='idRIO'
                                    name='id'
                                    placeholder=""
                                    className={`inputbox ${validationStates.idRIO === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('idRIO', /^[\w\W,]+$/)}
                                />
                                {hoveredField === 'id' && (
                                    <div className="hover-description">
                                        Entrez l'ID RIO
                                    </div>
                                )}
                            </Col>
                        </Row>

                    </div>
                );
            case 'no':
                return (
                    <div></div>
                );
            default:
                return null;
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    //function to get BusinessTelInstaller
    function getBusinessTelInstaller(iName, iAddress, iTelephone) {
        if (!iName && !iAddress && !iTelephone) {
            return {};
        }
        return {
            "name": iName,
            "address": iAddress,
            "telephone": iTelephone
        };
    }

    const json = {
        "country": {
            "country": "France",
            "customerDetails": {
                "name": name,
                "companyName": companyName,
                "legalForm": legalForm,
                "amount": amount,
                "address": address,
                "city": city,
                "number": number,
                "customerRole": customerRole,
                "operator": operator,
                "necessaryAct": necessaryAct,
                "signature": signature
            },
            "site": {
                "client": {
                    "sitesNumber": sitesNumber,
                    "siteClient": siteClient,
                    "siteCompanyName": siteCompanyName,
                    "siteName": siteName,
                    "siteAddress": siteAddress,
                    "postalCode": postalCode,
                    "locality": locality,
                    "telephone": telephone,
                    "fax": fax,
                    "idCode": idCode,
                    "siteOperator": siteOperator,
                    "tickbox": tickbox,
                    "portability": portability
                }
            },
            "portability": {
                "dateAndTime": {
                    "date": date,
                    "time": time
                },
                "connectionType": {
                    "mainline": isMainline,
                    "phoneNumber": phoneNumber,
                    "DIDRange": tableData
                },
                "businessTelInstaller": getBusinessTelInstaller(iName, iAddress, iTelephone),
                "rioDetails": {
                    "rio": formData
                }
            }
        },
        "email": sessionStorage.getItem('email'),
    }

    const jsonString = JSON.stringify(json);


    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        // Validate each field and set validation error with specific messages
        if (!name) {
            validationErrors.name = 'Veuillez remplir le nom.';
        }
        if (!companyName) {
            validationErrors.companyName = 'Veuillez remplir le nom de l\'entreprise.';
        }
        if (!legalForm) {
            validationErrors.legalForm = 'Veuillez remplir la forme juridique.';
        }
        if (!amount) {
            validationErrors.amount = 'Veuillez remplir le montant.';
        }
        if (!address) {
            validationErrors.address = 'Veuillez remplir l\'adresse.';
        }
        if (!city) {
            validationErrors.city = 'Veuillez remplir la ville.';
        }
        if (!number) {
            validationErrors.number = 'Veuillez remplir le numéro.';
        }
        if (!customerRole) {
            validationErrors.customerRole = 'Veuillez remplir le rôle du client.';
        }
        if (!operator) {
            validationErrors.operator = 'Veuillez remplir l\'opérateur.';
        }
        if (!necessaryAct) {
            validationErrors.necessaryAct = 'Veuillez spécifier l\'acte nécessaire.';
        }
        if (!signature) {
            validationErrors.signature = 'Veuillez remplir l\'emplacement de signature du formulaire.';
        }
        if (!date) {
            validationErrors.date = 'Veuillez remplir la date.';
        }
        if (!time) {
            validationErrors.time = 'Veuillez remplir l\'heure.';
        }
        if (!phoneNumber) {
            validationErrors.phoneNumber = 'Veuillez remplir le NDI.';
        }
        if (!sitesNumber) {
            validationErrors.sitesNumber = 'Veuillez renseigner le nombre de sites clients.';
        }
        if (!siteCompanyName) {
            validationErrors.siteCompanyName = "Veuillez renseigner le nom de l'entreprise.";
        }
        if (!siteName) {
            validationErrors.siteName = "Veuillez renseigner le nom du représentant.";
        }
        if (!siteAddress) {
            validationErrors.siteAddress = "Veuillez renseigner l'adresse";
        }
        if (!postalCode) {
            validationErrors.postalCode = 'Veuillez renseigner le code postal.';
        }
        if (!locality) {
            validationErrors.locality = 'Veuillez renseigner la localité.';
        }
        if (!telephone) {
            validationErrors.telephone = 'Veuillez renseigner le numéro de téléphone.';
        }
        if (!fax) {
            validationErrors.fax = 'Veuillez renseigner le numéro de fax.';
        }
        if (!idCode) {
            validationErrors.idCode = 'Veuillez renseigner le numéro SIRET.';
        }

        // Validate tableData DID ranges
        tableData.forEach(row => {
            const startId = `start-${row.id}`;
            const endId = `end-${row.id}`;

            if (!row.DIDRangeStart) {
                validationErrors[startId] = 'Veuillez remplir le début de la plage DID.';
            } else if (!/^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStart)) {
                validationErrors[startId] = 'Veuillez entrer un numéro DID de début valide.';
            }

            if (!row.DIDRangeStop) {
                validationErrors[endId] = 'Veuillez remplir la fin de la plage DID.';
            } else if (!/^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStop)) {
                validationErrors[endId] = 'Veuillez entrer un numéro DID de fin valide.';
            }
        });

        if (!selectedOption) {
            validationErrors.rio = 'Veuillez spécifier si le RIO est nécessaire ou non.';
        }
        if (selectedOption === 'yes') {
            if (!formData.accessType) {
                validationErrors.accessTypeRIO = 'Veuillez remplir le type d\'accès dans le champ RIO.';
            }
            if (!formData.number) {
                validationErrors.numberRIO = 'Veuillez remplir le numéro dans le champ RIO.';
            }
            if (!formData.id) {
                validationErrors.idRIO = 'Veuillez remplir l\'ID RIO.';
            }
        }

        // Combine keys from errors and current validationStates to update all validation flags
        const allKeys = new Set([
            ...Object.keys(validationErrors),
            ...Object.keys(validationStates)
        ]);

        let newValidationStates = {};
        allKeys.forEach(key => {
            newValidationStates[key] = !(key in validationErrors);
        });

        // Update validationStates state
        setValidationStates(newValidationStates);

        // Check if there are any validation errors
        const hasValidationError = Object.keys(validationErrors).length > 0;

        if (hasValidationError) {
            // Scroll to the first error and show toast
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstError = validationErrors[firstErrorKey];
            const elem = document.getElementById(firstErrorKey);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            }
            toast.error(firstError);
            return;
        }

        // Proceed with submission if no validation errors
        const data = jsonString; // your prepared JSON string for submission

        dispatch(generateLoa({ data, companyName })).then(response => {
            if (!response.error) {
                toast.success('LOA generated successfully');
            } else {
                window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
            }
        }).catch(() => {
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        });
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": email };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));

        const dataToBeSaved = { "email": email, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>


                <Container>

                    <p><strong>Les champs obligatoires sont marqués d'un *</strong></p> <br></br>

                    <h2 className='heading'>Détails du client</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nom*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id="name"
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[a-zA-Z\s]+$/)}

                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Entrez votre nom (e.g. BONGIBAULT)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Raison Sociale*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id="companyName"
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Entrez le nom de votre entreprise (e.g. AMEFO)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('legalForm')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Forme juridique*</label> <br />
                            <input
                                onChange={(e) => setLegalForm(e.target.value)}
                                type="text"
                                id="legalForm"
                                placeholder=""
                                className={`inputbox ${validationStates.legalForm === false ? 'error' : ''}`}
                                onBlur={() => validateInput('legalForm', /^[a-zA-Z\s]+$/)}

                            />
                            {hoveredField === 'legalForm' && (
                                <div className="hover-description">
                                    Entrez votre forme juridique (e.g. SAS)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('amount')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Montant en chiffre du capital*</label> <br />
                            <input
                                value={amount}
                                onChange={handleCapitalChange} // Use the new change handler
                                type="text"
                                id="amount"
                                placeholder=""
                                className={`inputbox ${validationStates.amount === false ? 'error' : ''}`}
                                onBlur={() => validateInput('amount', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'amount' && (
                                <div className="hover-description">
                                    Saisir le montant du capital en chiffres (e.g. 584000)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Adresse du siège social*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Entrez l'adresse du siège social (e.g. 170 Quai Pasteur)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>RCS Ville*</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /^[a-zA-Z\s]+$/)}
                            />
                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Entrez Registre du Commerce et des Sociétés (e.g. CHAMBILLY)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('number')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Siren Numéro*</label> <br />
                            <input
                                onChange={(e) => setNumber(e.target.value)}
                                type="text"
                                id="number"
                                placeholder=""
                                className={`inputbox ${validationStates.number === false ? 'error' : ''}`}
                                onBlur={() => validateInput('number', /^\d{9}$/)}
                            />
                            {hoveredField === 'number' && (
                                <div className="hover-description">
                                    Entrez le numéro à 9 chiffres (e.g. 498252458)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('operator')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Opérateur Actuel*</label> <br />
                            <select
                                onChange={(e) => setOperator(e.target.value)}
                                id="operator"
                                className={`inputbox ${validationStates.operator === false ? 'error' : ''}`}
                                onBlur={() => validateInput('operator', /^[\w\W,]+$/)}
                            >
                                <option value=""></option>
                                <option value="4 connect">4 connect</option>
                                <option value="440HZ">440HZ</option>
                                <option value="8x8 UK Limited">8x8 UK Limited</option>
                                <option value="AB plus">AB plus</option>
                                <option value="Abaclouda">Abaclouda</option>
                                <option value="ADD-ON Consulting">ADD-ON Consulting</option>
                                <option value="Adenis">Adenis</option>
                                <option value="Aircall">Aircall</option>
                                <option value="Akinea Internet">Akinea Internet</option>
                                <option value="Alcacom">Alcacom</option>
                                <option value="Alpes networks">Alpes networks</option>
                                <option value="Alphalink">Alphalink</option>
                                <option value="Always on (ex Leonix Telecom)">Always on (ex Leonix Telecom)</option>
                                <option value="AMCS LLC">AMCS LLC</option>
                                <option value="Appliwave">Appliwave</option>
                                <option value="Atlasinvest OU">Atlasinvest OU</option>
                                <option value="Auranext (Emod)">Auranext (Emod)</option>
                                <option value="AVM Informatique">AVM Informatique</option>
                                <option value="Axialys">Axialys</option>
                                <option value="AZA Telecom">AZA Telecom</option>
                                <option value="BBS Informatique">BBS Informatique</option>
                                <option value="Bee Technology">Bee Technology</option>
                                <option value="Bersam telephone">Bersam telephone</option>
                                <option value="BICS">BICS</option>
                                <option value="BJT Partners">BJT Partners</option>
                                <option value="Bookline Solutions SL">Bookline Solutions SL</option>
                                <option value="Bouygues Telecom">Bouygues Telecom</option>
                                <option value="Bretagne Telecom">Bretagne Telecom</option>
                                <option value="Canal+ Telecom (ex Mediaserv)">Canal+ Telecom (ex Mediaserv)</option>
                                <option value="Capacom">Capacom</option>
                                <option value="Celeonet">Celeonet</option>
                                <option value="Celeste">Celeste</option>
                                <option value="Cloud telecom">Cloud telecom</option>
                                <option value="CM Telecom France">CM Telecom France</option>
                                <option value="CMRP">CMRP</option>
                                <option value="Colt">Colt</option>
                                <option value="Commentaires">Commentaires</option>
                                <option value="Completel (Entreprise)">Completel (Entreprise)</option>
                                <option value="Completel (GP)">Completel (GP)</option>
                                <option value="Completel (Opérateur)">Completel (Opérateur)</option>
                                <option value="Comunik CRM">Comunik CRM</option>
                                <option value="Connect managed services (UK) Limited">Connect managed services (UK) Limited</option>
                                <option value="Connectics">Connectics</option>
                                <option value="Coriolis (ex MYSTREAM)">Coriolis (ex MYSTREAM)</option>
                                <option value="Courrier">Courrier</option>
                                <option value="Destiny France Partenaires (ex OpenIP)">Destiny France Partenaires (ex OpenIP)</option>
                                <option value="Destiny global infra services">Destiny global infra services</option>
                                <option value="Dial once France">Dial once France</option>
                                <option value="Dialpad">Dialpad</option>
                                <option value="DIDWW Ireland Limited">DIDWW Ireland Limited</option>
                                <option value="Digicel">Digicel</option>
                                <option value="Digimium">Digimium</option>
                                <option value="Dimension Telecom">Dimension Telecom</option>
                                <option value="DVS Connect">DVS Connect</option>
                                <option value="Dynamik cloud & télécom">Dynamik cloud & télécom</option>
                                <option value="eGroup technologies AG">eGroup technologies AG</option>
                                <option value="Eis SRL">Eis SRL</option>
                                <option value="Elit Technologies">Elit Technologies</option>
                                <option value="email">email</option>
                                <option value="E-NEOLAB">E-NEOLAB</option>
                                <option value="ENREACH">ENREACH</option>
                                <option value="E-OLYMPE">E-OLYMPE</option>
                                <option value="Eurofiber France">Eurofiber France</option>
                                <option value="Even media interactive">Even media interactive</option>
                                <option value="EvolveIP Ltd">EvolveIP Ltd</option>
                                <option value="Eway">Eway</option>
                                <option value="Excentre">Excentre</option>
                                <option value="FC telecom">FC telecom</option>
                                <option value="Five9 GmbH">Five9 GmbH</option>
                                <option value="Flex network">Flex network</option>
                                <option value="Foliateam (ex Acropolis)">Foliateam (ex Acropolis)</option>
                                <option value="Fonitex technologie">Fonitex technologie</option>
                                <option value="Free">Free</option>
                                <option value="Free Pro (ex Jaguar Network)">Free Pro (ex Jaguar Network)</option>
                                <option value="Genesys cloud services BV">Genesys cloud services BV</option>
                                <option value="Get & go telecom">Get & go telecom</option>
                                <option value="Google Cloud France">Google Cloud France</option>
                                <option value="Goto technologies Ireland unlimited">Goto technologies Ireland unlimited</option>
                                <option value="Graphnet France">Graphnet France</option>
                                <option value="Groupe Convergence.com">Groupe Convergence.com</option>
                                <option value="GS Communication">GS Communication</option>
                                <option value="GTT COMMUNICATIONS France">GTT COMMUNICATIONS France</option>
                                <option value="Hexanet">Hexanet</option>
                                <option value="Hexatel">Hexatel</option>
                                <option value="Ibrowse">Ibrowse</option>
                                <option value="Idline">Idline</option>
                                <option value="Ikacom">Ikacom</option>
                                <option value="Infinivox">Infinivox</option>
                                <option value="Integraphone">Integraphone</option>
                                <option value="Iovox">Iovox</option>
                                <option value="IP Directions">IP Directions</option>
                                <option value="IP telecom Bulgaria Ltd">IP telecom Bulgaria Ltd</option>
                                <option value="Ipefix">Ipefix</option>
                                <option value="IPXTEL">IPXTEL</option>
                                <option value="ISI-COM">ISI-COM</option>
                                <option value="Kaisa Technologies AB">Kaisa Technologies AB</option>
                                <option value="Kav El International">Kav El International</option>
                                <option value="Keyyo">Keyyo</option>
                                <option value="K-net">K-net</option>
                                <option value="Koesio networks">Koesio networks</option>
                                <option value="Komeo">Komeo</option>
                                <option value="LAB SBH">LAB SBH</option>
                                <option value="Legos">Legos</option>
                                <option value="Lineconnects">Lineconnects</option>
                                <option value="Linkt">Linkt</option>
                                <option value="Longphone">Longphone</option>
                                <option value="Loopup Spain">Loopup Spain</option>
                                <option value="Lumen Technologies France">Lumen Technologies France</option>
                                <option value="Manifone">Manifone</option>
                                <option value="MASERGY COMMUNICATIONS UK Limited">MASERGY COMMUNICATIONS UK Limited</option>
                                <option value="Masselin communication">Masselin communication</option>
                                <option value="MCT">MCT</option>
                                <option value="Microsoft Ireland operations limited">
                                    Microsoft Ireland operations limited
                                </option>
                                <option value="Mixvoip S.A.">Mixvoip S.A.</option>
                                <option value="Morgon technologies">Morgon technologies</option>
                                <option value="Muona">Muona</option>
                                <option value="Mybestpro">Mybestpro</option>
                                <option value="Neotel">Neotel</option>
                                <option value="Netalis">Netalis</option>
                                <option value="Netiwan">Netiwan</option>
                                <option value="Nettel">Nettel</option>
                                <option value="Netwo">Netwo</option>
                                <option value="Nexera (ex Netcom Group)">Nexera (ex Netcom Group)</option>
                                <option value="Nexto - Fiducial Cloud">Nexto - Fiducial Cloud</option>
                                <option value="Nfon France">Nfon France</option>
                                <option value="NICE Systems UK Limited">NICE Systems UK Limited</option>
                                <option value="Nomotech (ex KERTEL)">Nomotech (ex KERTEL)</option>
                                <option value="Nordnet">Nordnet</option>
                                <option value="Novelcom">Novelcom</option>
                                <option value="NTT France">NTT France</option>
                                <option value="Nuwave Communications Limited">Nuwave Communications Limited</option>
                                <option value="NXO France">NXO France</option>
                                <option value="Occicom">Occicom</option>
                                <option value="Odigo (ex Prosodie)">Odigo (ex Prosodie)</option>
                                <option value="Onecentral BV">Onecentral BV</option>
                                <option value="Onoff telecom">Onoff telecom</option>
                                <option value="OPS Telecom">OPS Telecom</option>
                                <option value="Orange">Orange</option>
                                <option value="Orange Business Services">Orange Business Services</option>
                                <option value="Orange France">Orange France</option>
                                <option value="Orne THD">Orne THD</option>
                                <option value="OVEA">OVEA</option>
                                <option value="Oxilog">Oxilog</option>
                                <option value="Paritel Opérateur">Paritel Opérateur</option>
                                <option value="Peoplefone SAS">Peoplefone SAS</option>
                                <option value="Phibee Telecom (ex Chmurtz)">Phibee Telecom (ex Chmurtz)</option>
                                <option value="Phone.GS">Phone.GS</option>
                                <option value="Plug and tel">Plug and tel</option>
                                <option value="Prosoluce">Prosoluce</option>
                                <option value="Provectio">Provectio</option>
                                <option value="Pure IP Limited">Pure IP Limited</option>
                                <option value="Réseau concept">Réseau concept</option>
                                <option value="RETARUS GMBH">RETARUS GMBH</option>
                                <option value="Ringcentral France">Ringcentral France</option>
                                <option value="Rinkel B.V.">Rinkel B.V.</option>
                                <option value="RMI - Adista">RMI - Adista</option>
                                <option value="Sabio">Sabio</option>
                                <option value="SDCI">SDCI</option>
                                <option value="Serinya">Serinya</option>
                                <option value="Service distribution informatique Roca">
                                    Service distribution informatique Roca
                                </option>
                                <option value="Setera Communications Oy">Setera Communications Oy</option>
                                <option value="Sewan Communications">Sewan Communications</option>
                                <option value="SFR (DSO)">SFR (DSO)</option>
                                <option value="SFR (Entreprise)">SFR (Entreprise)</option>
                                <option value="SFR (GP)">SFR (GP)</option>
                                <option value="SFR Fibre SAS (ex Numericable)">SFR Fibre SAS (ex Numericable)</option>
                                <option value="Six degrees technology group Limited">
                                    Six degrees technology group Limited
                                </option>
                                <option value="Solutions Informatiques Services">
                                    Solutions Informatiques Services
                                </option>
                                <option value="Spacinov">Spacinov</option>
                                <option value="SRR (Entreprise)">SRR (Entreprise)</option>
                                <option value="SRR (GP)">SRR (GP)</option>
                                <option value="Stephie Telecom">Stephie Telecom</option>
                                <option value="Synelyans">Synelyans</option>
                                <option value="Talkcycle LLC DBA FrontSpin">Talkcycle LLC DBA FrontSpin</option>
                                <option value="TATA COMMUNICATIONS France">TATA COMMUNICATIONS France</option>
                                <option value="Teambox">Teambox</option>
                                <option value="Tel@ndcloud">Tel@ndcloud</option>
                                <option value="Telavox">Telavox</option>
                                <option value="Telecom Object">Telecom Object</option>
                                <option value="Trinaps">Trinaps</option>
                                <option value="Trustteam">Trustteam</option>
                                <option value="Twilio Ireland Limited">Twilio Ireland Limited</option>
                                <option value="Ty-line">Ty-line</option>
                                <option value="Ubefone (ex Telecom Studio)">Ubefone (ex Telecom Studio)</option>
                                <option value="Ubicentrex">Ubicentrex</option>
                                <option value="Unyc (ex Serveurcom)">Unyc (ex Serveurcom)</option>
                                <option value="VA Solutions">VA Solutions</option>
                                <option value="Verizon France">Verizon France</option>
                                <option value="Viadialog">Viadialog</option>
                                <option value="Voip telecom">Voip telecom</option>
                                <option value="Vonage BV">Vonage BV</option>
                                <option value="Voxnode">Voxnode</option>
                                <option value="VOYS">VOYS</option>
                                <option value="Watsoft distribution">Watsoft distribution</option>
                                <option value="Wildix EE OU">Wildix EE OU</option>
                                <option value="Worldline">Worldline</option>
                                <option value="Yoot IT">Yoot IT</option>
                                <option value="ZE telecom">ZE telecom</option>
                                <option value="Zeop">Zeop</option>
                                <option value="Zoom voice communications Inc.">Zoom voice communications Inc.</option>
                            </select>
                            {hoveredField === 'operator' && (
                                <div className="hover-description">
                                    Entrez l'opérateur (e.g. BOUYGUES)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('customerRole')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Rôle du client dans l'organisation*</label> <br />
                            <input
                                onChange={(e) => setCustomerRole(e.target.value)}
                                type="text"
                                id="customerRole"
                                placeholder=""
                                className={`inputbox ${validationStates.customerRole === false ? 'error' : ''}`}
                                onBlur={() => validateInput('customerRole', /^[a-zA-Z\s]+$/)}
                            />
                            {hoveredField === 'customerRole' && (
                                <div className="hover-description">
                                    Saisissez le rôle du client dans l'organisation (e.g. Directeur General)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>
                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('necessaryAct')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Acte Nécessaire*</label> <br />
                            <select
                                id="necessaryAct"
                                onChange={(e) => setNecessaryAct(e.target.value)}
                                className={`inputbox ${validationStates.necessaryAct === false ? 'error' : ''}`}
                                onBlur={() => validateInput('necessaryAct', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="à la mise en œuvre de la portabilité">
                                    À la mise en œuvre de la portabilité
                                </option>
                                <option value="à la résiliation de mon(mes) offre(s) sans mise en œuvre de la portabilité">
                                    À la résiliation de mon(mes) offre(s) sans mise en œuvre de la portabilité
                                </option>
                            </select>
                            {hoveredField === 'necessaryAct' && (
                                <div className="hover-description">
                                    Choisissez l'action nécessaire
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Lieu*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id="signature"
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /^[a-zA-Z\s]+$/)}
                            />
                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Signature du lieu
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Détails du site</h2> <br></br>

                    <br></br>

                    <div>
                        <Row>
                            <Col onMouseEnter={() => handleMouseEnter("siteClient")} onMouseLeave={handleMouseLeave}>
                                <label>Site Client</label> <br />
                                <input
                                    id="siteClient"
                                    type="text"
                                    name="siteClient"
                                    value={siteClient}
                                    onChange={(e) => setSiteClient(e.target.value)}
                                    className={`inputbox`}
                                //onBlur={() => validateInput("siteClient", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteClient" && <div className="hover-description">Entrez le nom du site client</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("sitesNumber")} onMouseLeave={handleMouseLeave}>
                                <label>Nombre de sites clients*</label> <br />
                                <input
                                    id="sitesNumber"
                                    type="text"
                                    name="sitesNumber"
                                    value={sitesNumber}
                                    onChange={(e) => setSitesNumber(e.target.value)}
                                    className={`inputbox ${validationStates["sitesNumber"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("sitesNumber", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "sitesNumber" && <div className="hover-description">Entrez le nombre de sites clients</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("siteCompanyName")} onMouseLeave={handleMouseLeave}>
                                <label>Nom de l'entreprise*</label> <br />
                                <input
                                    id="siteCompanyName"
                                    type="text"
                                    name="siteCompanyName"
                                    value={siteCompanyName}
                                    onChange={(e) => setSiteCompanyName(e.target.value)}
                                    className={`inputbox ${validationStates["siteCompanyName"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("siteCompanyName", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteCompanyName" && <div className="hover-description">Entrez le nom de l'entreprise</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("siteName")} onMouseLeave={handleMouseLeave}>
                                <label>Représenté par*</label> <br />
                                <input
                                    id="siteName"
                                    type="text"
                                    name="siteName"
                                    value={siteName}
                                    onChange={(e) => setSiteName(e.target.value)}
                                    className={`inputbox ${validationStates["siteName"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("siteName", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteName" && <div className="hover-description">Entrez le nom du représentant</div>}
                            </Col>
                        </Row>

                        <br />

                        <Row>

                            <Col onMouseEnter={() => handleMouseEnter("siteAddress")} onMouseLeave={handleMouseLeave}>
                                <label>Adresse*</label> <br />
                                <input
                                    id="siteAddress"
                                    type="text"
                                    name="siteAddress"
                                    value={siteAddress}
                                    onChange={(e) => setSiteAddress(e.target.value)}
                                    className={`inputbox ${validationStates["siteAddress"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("siteAddress", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteAddress" && <div className="hover-description">Entrez l'adresse</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("postalCode")} onMouseLeave={handleMouseLeave}>
                                <label>Code Postal*</label> <br />
                                <input
                                    id="postalCode"
                                    type="text"
                                    name="postalCode"
                                    value={postalCode}
                                    onChange={(e) => setPostalCode(e.target.value)}
                                    className={`inputbox ${validationStates["postalCode"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("postalCode", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "postalCode" && <div className="hover-description">Entrez le code postal</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("locality")} onMouseLeave={handleMouseLeave}>
                                <label>Localité*</label> <br />
                                <input
                                    id="locality"
                                    type="text"
                                    name="locality"
                                    value={locality}
                                    onChange={(e) => setLocality(e.target.value)}
                                    className={`inputbox ${validationStates["locality"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("locality", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "locality" && <div className="hover-description">Entrez la localité</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("telephone")} onMouseLeave={handleMouseLeave}>
                                <label>Numéro de téléphone*</label> <br />
                                <input
                                    id="telephone"
                                    type="text"
                                    name="telephone"
                                    value={telephone}
                                    onChange={(e) => setTelephone(e.target.value)}
                                    className={`inputbox ${validationStates["telephone"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("telephone", /^\+?[1-9]\d{1,14}$/)}
                                />
                                {hoveredField === "telephone" && <div className="hover-description">Entrez le numéro de téléphone</div>}
                            </Col>

                        </Row>

                        <br />

                        <Row>
                            <Col onMouseEnter={() => handleMouseEnter("fax")} onMouseLeave={handleMouseLeave}>
                                <label>Adresse e-mail*</label> <br />
                                <input
                                    id="fax"
                                    type="text"
                                    name="fax"
                                    value={fax}
                                    onChange={(e) => setFax(e.target.value)}
                                    className={`inputbox ${validationStates["fax"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("fax", /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$/)}
                                />
                                {hoveredField === "fax" && <div className="hover-description">Entrez l'adresse e-mail</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("idCode")} onMouseLeave={handleMouseLeave}>
                                <label>Numéro SIRET*</label> <br />
                                <input
                                    id="idCode"
                                    type="text"
                                    name="idCode"
                                    value={idCode}
                                    onChange={(e) => setIdCode(e.target.value)}
                                    className={`inputbox ${validationStates["idCode"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("idCode", /^\d{14}$/)}
                                />
                                {hoveredField === "idCode" && <div className="hover-description">Entrez le numéro SIRET à 14 chiffres</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("siteOperator")} onMouseLeave={handleMouseLeave}>
                                <label>Opérateur actuel</label> <br />
                                <input
                                    id="siteOperator"
                                    type="text"
                                    name="siteOperator"
                                    value={operator}
                                    onChange={(e) => setSiteOperator(e.target.value)}
                                    className="inputbox"
                                />
                                {hoveredField === "siteOperator" && <div className="hover-description">Entrez l'opérateur actuel</div>}
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col onMouseEnter={() => handleMouseEnter("tickbox")} onMouseLeave={handleMouseLeave}>
                                <label>Type d'offre</label> <br />
                                <select
                                    name="tickbox"
                                    id="tickbox"
                                    value={tickbox}
                                    onChange={(e) => setTickbox(e.target.value)}
                                    className="inputbox"
                                >
                                    <option value=""></option>
                                    <option value="Offre de préselection">Offre de préselection</option>
                                    <option value="Dégroupage partiel">Dégroupage partiel</option>
                                    <option value="Accès DSL">Accès DSL</option>
                                </select>
                                {hoveredField === "tickbox" && <div className="hover-description">Sélectionnez le type d'offre</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("portability")} onMouseLeave={handleMouseLeave}>
                                <label>Portabilité des numéros</label> <br />
                                <select
                                    name="portability"
                                    id="portability"
                                    value={portability}
                                    onChange={(e) => setPortability(e.target.value)}
                                    className="inputbox"
                                >
                                    <option value=""></option>
                                    <option value="Partielle">Partielle</option>
                                    <option value="Complète">Complète</option>
                                </select>
                                {hoveredField === "portability" && <div className="hover-description">Choisissez la portabilité des numéros</div>}
                            </Col>
                        </Row>

                    </div>


                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Date et l'heure</h2> <br></br>
                    <h6 className='heading'>**L'acceptation du temps est soumise à la disponibilité de l'équipe de portage</h6>


                    <Row>
                        <Col>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date} // Automatically set the current date
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                        </Col>

                        <Col>
                            <label>Temps*</label> <br></br>
                            <input
                                onChange={(e) => setTime(e.target.value)}
                                type="time"
                                id='time'
                                placeholder=""
                                className={`inputbox ${validationStates.time === false ? 'error' : ''}`}
                                onBlur={() => validateInput('time', /^.*$/)}
                            />
                        </Col>
                        <Col>
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Type de connexion</h2> <br></br>

                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="mainline"
                                    name="mainline"
                                    checked={isMainline} // Bind state to checked attribute
                                    onChange={(e) => setIsMainline(e.target.checked)} // Handle checkbox change                
                                />
                                <label htmlFor="mainline">&nbsp; Le portage du numéro de ligne principale est-il également requis</label>
                            </div>
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('phoneNumber')}
                            onMouseLeave={handleMouseLeave}
                            xs={3}
                        >
                            <label>NDI*</label> <br />
                            <input
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                type="text"
                                id='phoneNumber'
                                placeholder=""
                                className={`inputbox ${validationStates.phoneNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('phoneNumber', /^\+?[1-9]\d{1,14}$/)}
                            />
                            {hoveredField === 'phoneNumber' && (
                                <div className="hover-description">
                                    Entrez le numéro de désignation d’installation
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '280px' // Set a consistent width for both buttons
                                }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Télécharger le fichier
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button
                                className="inputbox"
                                onClick={handleDownload}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '100px', // Match the width to the first button
                                    marginRight: '300px'
                                }}
                            >
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Télécharger le modèle de tranche de numéros
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Retirer
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Fichier téléchargé: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>Le modèle est le même que celui utilisé pour la demande de portabilité btd.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>SDA premier numéro dans plage*</th>
                                <th>SDA dernier numéro dans plage*</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, index) => (
                                <tr key={row.id}>
                                    {/* <td>
                                        <input
                                            type="text"
                                            id={`start-${row.id}`} // Dynamic ID for start input
                                            value={row.DIDRangeStart}
                                            onChange={(e) => handleChange_table(row.id, 'DIDRangeStart', e.target.value)}
                                            className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => validateInput(`start-${row.id}`, /^\+?[1-9]\d{1,14}$/)}
                                        />
                                    </td> */}
                                    <td>
                                        <input
                                            type="text"
                                            id={`start-${row.id}`} // Dynamic ID for start input
                                            value={row.DIDRangeStart}
                                            onChange={(e) => handleChange_table(row.id, 'DIDRangeStart', e.target.value)}
                                            className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Validate for 1 to 14 digits with an optional '+' sign
                                                const isValid = /^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStart);
                                                if (!isValid) {
                                                    toast.error('Input must be between 1 to 14 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`start-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`start-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                        />
                                    </td>

                                    <td>
                                        <input
                                            type="text"
                                            id={`end-${row.id}`} // Dynamic ID for end input
                                            value={row.DIDRangeStop}
                                            onChange={(e) => handleChange_table(row.id, 'DIDRangeStop', e.target.value)}
                                            className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Validate for 1 to 14 digits with an optional '+' sign
                                                const isValid = /^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStop);
                                                if (!isValid) {
                                                    toast.error('Input must be between 1 to 14 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`end-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`end-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                        />
                                    </td>


                                    {/* <td>
                                        <input
                                            type="text"
                                            id={`end-${row.id}`} // Dynamic ID for end input
                                            value={row.DIDRangeStop}
                                            onChange={(e) => handleChange_table(row.id, 'DIDRangeStop', e.target.value)}
                                            className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => validateInput(`end-${row.id}`, /^\+?[1-9]\d{1,14}$/)}
                                        />
                                    </td> */}
                                    <td>
                                        {tableData.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Retirer</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <button onClick={addRow}>Ajouter une ligne</button>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Installateur en téléphonie d’entreprise</h2> <br></br>
                    <h6 className='heading'>**Cette section est facultative et peut être laissée vide</h6>


                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('iName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nom</label> <br />
                            <input
                                onChange={(e) => setIName(e.target.value)}
                                type="text"
                                id='iName'
                                placeholder=""
                                className="inputbox"
                            />
                            {hoveredField === 'iName' && (
                                <div className="hover-description">
                                    Entrez votre nom
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('iAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Adresse</label> <br />
                            <input
                                onChange={(e) => setIAddress(e.target.value)}
                                type="text"
                                id='iAddress'
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'iAddress' && (
                                <div className="hover-description">
                                    Entrez votre adresse
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('iTelephone')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Téléphone</label> <br />
                            <input
                                onChange={(e) => setITelephone(e.target.value)}
                                type="text"
                                id='iTelephone'
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'iTelephone' && (
                                <div className="hover-description">
                                    Entrez votre numéro de téléphone
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>RIO détails</h2> <br></br>

                    <Row>
                        {/* <Col xs={8}>
                            <label>Si RIO nécessaire</label> <br></br>
                            <select id="rio" value={selectedOption} onChange={handleDropdownChange} className='inputbox'>
                                <option value="">Select</option>
                                <option value="no">Non</option>
                                <option value="yes">Oui</option>
                            </select>
                            <br></br>
                            {renderFormInputs()}
                        </Col> */}

                        <Col xs={8}>
                            <label>Si RIO nécessaire*</label> <br></br>
                            <select
                                id="rio"
                                value={selectedOption}
                                onChange={handleDropdownChange}
                                className={`inputbox ${validationStates.rio === false ? 'error' : ''}`}
                                onBlur={() => validateInput('rio', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="no">Non</option>
                                <option value="yes">Oui</option>
                            </select>
                            <br></br><br></br>
                            {renderFormInputs()}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <LoadingButton
                        variant="primary"
                        type="submit"
                        onClick={Submit}
                        isLoading={generateLoading}
                    >
                        Generate LOA
                    </LoadingButton>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default French;